import { QRCodeSVG } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

// Fullscreen-friendly QR you can flash on the iPad during a live pitch.
// The invited dealer scans it with their phone, lands on /signup?token=…
// with everything pre-filled, and one thumbprint later they're on Stripe.
export default function InviteQrModal({ url, dealership, email, open, onOpenChange }) {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Couldn't copy — copy from the address bar");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="invite-qr-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Scan to claim your seat</DialogTitle>
          <DialogDescription>
            {dealership ? <span><span className="font-semibold text-navy">{dealership}</span> — </span> : null}
            hand the iPad over and let them scan. Signup form pre-fills automatically.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-2">
          <div className="p-4 bg-white rounded-lg border border-border shadow-sm" data-testid="invite-qr-code">
            <QRCodeSVG value={url} size={280} level="M" bgColor="#ffffff" fgColor="#0f172a" includeMargin={false} />
          </div>
          <div className="w-full space-y-2">
            <div className="text-[0.65rem] font-mono-label tracking-widest text-muted-foreground">SIGNUP LINK</div>
            <div className="flex items-center gap-2">
              <div className="flex-1 rounded-md border border-border bg-muted/30 px-3 py-2 font-mono text-xs break-all" data-testid="invite-qr-url">{url}</div>
              <Button size="sm" variant="outline" onClick={copyLink} data-testid="invite-qr-copy-btn">
                {copied ? <Check className="w-3.5 h-3.5 text-emerald-600" /> : <Copy className="w-3.5 h-3.5" />}
              </Button>
            </div>
            {email && (
              <div className="text-[0.7rem] text-muted-foreground">Emailed to <span className="font-mono">{email}</span> — this QR is the same link.</div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
